import { AuthContext } from "../../context/authContext.js"
import { useContext } from "react"
import "./ButtonLogout.css"
export default function ButtonLogout(){

    const {logout} = useContext(AuthContext)

    const handleLogout = async() => {
        await logout()
        window.location.reload()
    }

    return(
        <div>
            <button className="refresh-btn" onClick={handleLogout}>Cerrar sesion</button>
        </div>
    )
}